import { StatusBadge } from '@/components/Common/StatusBadge/StatusBadge';
import COLORS from '@/constants/colors';
import { useIsMobile } from '@/utils/isMobile';
import CloseIcon from '@mui/icons-material/Close';
import {
  Avatar,
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SelectedOrderUi } from './GlobalOrdersUi';

interface OrderDetailsProps {
  onClose: () => void;
  selectedOrderUi?: SelectedOrderUi;
  isLoading: boolean;
  error: string | null;
  open: boolean;
}

export const OrderDetailsDialog: React.FC<OrderDetailsProps> = ({
  onClose,
  selectedOrderUi,
  isLoading,
  error,
  open,
}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflowY: 'auto',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Pedido Global
          </Typography>
          <IconButton edge="end" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        ) : selectedOrderUi && selectedOrderUi.details.length > 0 ? (
          selectedOrderUi.details.map((detail) => (
            <Box
              key={detail.orderId}
              sx={{
                mt: 2,
                p: 2,
                border: '1px solid',
                borderColor: COLORS.gray_300,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate(`/admin/orders/detail/${detail.orderId}`);
              }}
            >
              <Avatar src={detail.sellerImage} sx={{ width: 48, height: 48 }} />
              <Box sx={{ flex: 1 }}>
                <Typography
                  component="div"
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600,
                    fontSize: '14px',
                    color: 'black',
                  }}
                >
                  {detail.sellerName}
                  <Box
                    component="span"
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      marginLeft: '6px',
                    }}
                  >
                    {detail.productQuantity} Piezas
                  </Box>
                </Typography>
                <Typography variant="body2" sx={{ color: 'black' }}>
                  Total: ${detail.totalOrderAmount}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '12px',
                    color: 'black',
                  }}
                >
                  Detalle del pedido {detail.orderNumber}
                </Typography>
              </Box>
              <StatusBadge badge={detail.badge} />
            </Box>
          ))
        ) : (
          <Typography sx={{ mt: 2 }}>No hay detalles disponibles.</Typography>
        )}
      </Box>
    </Box>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          margin: 0,
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          maxHeight: '100%',
          width: {
            xs: '100%',
            sm: '400px',
          },
          maxWidth: '600px',
        },
      }}
      hideBackdrop
    >
      {content}
    </Dialog>
  );
};
